// Restores 'debounce' and 'pauseAllMedia', which media-gallery.js and product-modal.js
// rely on but are missing from this theme's bundled assets/secondary.js.
// Must load before those scripts (it does, via this snippet).
if (typeof window.debounce !== 'function') {
  window.debounce = function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  };
}

if (typeof window.pauseAllMedia !== 'function') {
  window.pauseAllMedia = function pauseAllMedia() {
    document.querySelectorAll('.js-youtube').forEach((video) => {
      video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
    });
    document.querySelectorAll('.js-vimeo').forEach((video) => {
      video.contentWindow.postMessage('{"method":"pause"}', '*');
    });
    document.querySelectorAll('video').forEach((video) => video.pause());
    document.querySelectorAll('product-model').forEach((model) => {
      if (model.modelViewerUI) model.modelViewerUI.pause();
    });
  };
}

// Restores the 'dynamic-dates' custom element used by the 'Shipping checkpoints'
// block (snippets/shipping-checkpoints.liquid). That snippet server-renders '-'
// as a placeholder for [start_date]/[end_date] and relies on this element to
// replace it with a real computed date on load; the element's definition is
// missing from this theme's bundled assets/secondary.js, so every shipping
// checkpoints block on the site is stuck showing literal dashes.
if (!customElements.get('dynamic-dates')) {
  customElements.define('dynamic-dates', class DynamicDates extends HTMLElement {
    connectedCallback() {
      const format = this.dataset.dateFormat || 'mm_dd';
      const monthLabels = (this.dataset.monthLabels || '')
        .split(',')
        .map((label) => label.trim())
        .filter(Boolean);
      const today = new Date();

      const formatDate = (date) => {
        const day = date.getDate();
        const monthIndex = date.getMonth();
        if (format.indexOf('month') !== -1) {
          const monthName = monthLabels[monthIndex] || String(monthIndex + 1).padStart(2, '0');
          return format.indexOf('dd_month') === 0 ? `${day} ${monthName}` : `${monthName} ${day}`;
        }
        const mm = String(monthIndex + 1).padStart(2, '0');
        const dd = String(day).padStart(2, '0');
        return format.indexOf('dd_mm') === 0 ? `${dd}/${mm}` : `${mm}/${dd}`;
      };

      this.querySelectorAll('[data-dynamic-date="true"]').forEach((el) => {
        const text = el.dataset.text || '';
        const minDays = parseInt(el.dataset.minDays, 10) || 0;
        const maxDays = parseInt(el.dataset.maxDays, 10) || 0;

        const startDate = new Date(today);
        startDate.setDate(startDate.getDate() + minDays);
        const endDate = new Date(today);
        endDate.setDate(endDate.getDate() + maxDays);

        el.innerHTML = text
          .replace(/\[start_date\]/g, formatDate(startDate))
          .replace(/\[end_date\]/g, formatDate(endDate));
      });
    }
  });
}

if (!customElements.get('variant-selects')) {
  customElements.define('variant-selects', class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.currentOptions = this.getSelectedOptions();
      this.addEventListener('change', this.onVariantChange.bind(this));
    }

    onVariantChange() {
      const previousOptions = this.currentOptions;
      const selectedOptions = this.getSelectedOptions();
      this.updateLabels(previousOptions, selectedOptions);
      this.currentOptions = selectedOptions;

      const variant = this.getSelectedVariant();
      if (variant) {
        this.updateMedia(variant);
        this.updateVariantInput(variant);
      }
    }

    // Keeps every hidden `input[name="id"]` in the product form(s) in sync with the
    // selected variant. Without this, "Add to cart" and third-party order forms
    // (e.g. the Releasit COD form, which renders its own separate <form> here) keep
    // submitting whichever variant was selected first, no matter what the shopper picks.
    updateVariantInput(variant) {
      const container = document.getElementById(`ProductInfo-${this.dataset.section}`) || document;
      container.querySelectorAll('input[name="id"]').forEach((input) => {
        input.value = variant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    // The "Color: rojo" style label next to the picker is rendered server-side once,
    // from the initially selected variant, and never updates on its own. Since the
    // exact label template (block.settings.custom_labels) isn't known here, just swap
    // the old selected value for the new one inside whatever text is already there.
    updateLabels(previousOptions, selectedOptions) {
      selectedOptions.forEach((value, index) => {
        const previous = previousOptions[index];
        if (!value || !previous || value === previous) return;

        const label = document.getElementById(`custom-label-${this.dataset.section}-${index + 1}`);
        if (label && label.textContent.includes(previous)) {
          label.textContent = label.textContent.replace(previous, value);
        }
      });
    }

    getSelectedOptions() {
      return Array.from(this.querySelectorAll('.product-form__input')).map((wrapper) => {
        const select = wrapper.querySelector('select');
        if (select) return select.value;
        const checkedRadio = wrapper.querySelector('input[type="radio"]:checked');
        return checkedRadio ? checkedRadio.value : null;
      });
    }

    getSelectedVariant() {
      const script = this.querySelector('script[type="application/json"]');
      if (!script) return null;

      let variants;
      try {
        variants = JSON.parse(script.textContent);
      } catch (error) {
        return null;
      }

      const selectedOptions = this.getSelectedOptions();
      return variants.find((variant) =>
        variant.options.every((value, index) => value === selectedOptions[index])
      );
    }

    updateMedia(variant) {
      const mediaId = variant.featured_media ? variant.featured_media.id : null;
      if (!mediaId) return;

      const gallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
      if (gallery && typeof gallery.setActiveMedia === 'function') {
        gallery.setActiveMedia(`${this.dataset.section}-${mediaId}`, true);
      }
    }
  });
}
